module.exports = __webpack_public_path__ + "media/images/dashboard_icons/cash_discount-6c8f872f598866e376be05b6b3fe2328.svg";